import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  useSettings,
  FontFamily,
} from '@/museum-app/context/settings-context';
import {
  ToggleGroup,
  ToggleGroupItem,
} from '@/components/ui/toggle-group'; // Assuming shadcn/ui toggle-group is available

interface FontFamilyOption {
  value: FontFamily;
  labelKey: string; // Translation key
  defaultLabel: string; // Default label text
  className?: string; // Optional class for styling preview
}

const fontFamilyOptions: FontFamilyOption[] = [
  {
    value: 'sans-serif',
    labelKey: 'settings.fontFamily.sansSerif',
    defaultLabel: 'Sans Serif',
    className: 'font-sans', // Use Tailwind's font-sans
  },
  {
    value: 'serif',
    labelKey: 'settings.fontFamily.serif',
    defaultLabel: 'Serif',
    className: 'font-serif', // Use Tailwind's font-serif
  },
  {
    value: 'opendyslexic',
    labelKey: 'settings.fontFamily.openDyslexic',
    defaultLabel: 'OpenDyslexic',
    className: 'font-[OpenDyslexic]', // Apply the custom font
  },
];

const FontFamilySelector: React.FC = () => {
  const { fontFamily, setFontFamily } = useSettings();
  const { t } = useTranslation();

  const handleValueChange = (value: string) => {
    if (value) {
      setFontFamily(value as FontFamily);
    }
  };

  return (
    <ToggleGroup
      type="single"
      value={fontFamily}
      onValueChange={handleValueChange}
      aria-label={t('settings.fontFamily.ariaLabel', 'Select font family')}
      className="flex flex-wrap gap-2"
    >
      {fontFamilyOptions.map((option) => (
        <ToggleGroupItem
          key={option.value}
          value={option.value}
          aria-label={t(option.labelKey, option.defaultLabel)}
          className={`px-4 py-2 ${option.className ?? ''}`} // Apply font style to button
        >
          {t(option.labelKey, option.defaultLabel)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
};

export default FontFamilySelector;
